<script setup lang="ts">
import { storeToRefs } from 'pinia'
import AppToast from '@ui/components/feedback/AppToast.vue'
import { useToastStore } from '@/stores/toast.store'

const toastStore = useToastStore()
const { toasts } = storeToRefs(toastStore)
</script>

<template>
  <div
    id="toast-container"
    :class="[
      'z-50 fixed left-0 bottom-0 w-full max-h-full overflow-y-auto overflow-x-hidden',
      'flex flex-col-reverse gap-2.5 p-5',
      'sm:top-0 sm:bottom-auto sm:left-auto sm:right-0 sm:w-auto sm:flex-col',
    ]"
  >
    <TransitionGroup
      enter-active-class="transition transform ease-out duration-300"
      enter-from-class="translate-x-full opacity-0"
      enter-to-class="translate-x-0 opacity-100"
      leave-active-class="transition transform ease-in duration-300"
      leave-from-class="translate-x-0 opacity-100"
      leave-to-class="translate-x-full opacity-0"
    >
      <AppToast
        v-for="toast in toasts"
        :key="toast.id"
        v-bind="toast"
        :variant="toast.variant"
        @close="toastStore.removeToast(toast.id)"
      />
    </TransitionGroup>
  </div>
</template>
